import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';


const json = {

  1: { // Exercise num
    unit: 'Review 2',
    id: 'SB4-PV2-P49-E1',
    audio: '',
    video: '',
    component: D1,
    padding: 0,
    exerciseKey: 'img/FriendsPlus/Page49/E1/Key/answerKey.png',
    textAlign: 'center',
    maxLength: 1,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page49/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page49/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page49/E1/3.jpg', input: true, answer: "f" },
        { url: 'img/FriendsPlus/Page49/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page49/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page49/E1/6.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page49/E1/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page49/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page49/E1/9.jpg', input: true, answer: "e" },
        { url: 'img/FriendsPlus/Page49/E1/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page49/E1/11.jpg' },
        { url: 'img/FriendsPlus/Page49/E1/12.jpg', input: true, answer: "b" },
        { url: 'img/FriendsPlus/Page49/E1/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page49/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page49/E1/15.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page49/E1/16.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page49/E1/17.jpg' },
      ],



    ],
  },
  2: { // Exercise num
    unit: 'Review 2',
    id: 'SB4-PV2-P49-E2',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page49/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page49/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page49/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page49/E2/3.jpg', input: true, answer: "gets" },
        { url: 'img/FriendsPlus/Page49/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page49/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page49/E2/6.jpg', input: true, answer: "brushes" },
        { url: 'img/FriendsPlus/Page49/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page49/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page49/E2/9.jpg', input: true, answer: "catches" },
        { url: 'img/FriendsPlus/Page49/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page49/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page49/E2/12.jpg', input: true, answer: "walks" },
        { url: 'img/FriendsPlus/Page49/E2/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page49/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page49/E2/15.jpg', input: true, answer: "plays" },
        { url: 'img/FriendsPlus/Page49/E2/16.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page49/E2/17.jpg' },
      ],

    ]
  },
  3: { // Exercise num
    unit: 'Review 2',
    id: 'SB4-PV2-P49-E3',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page49/E3/Key/answerKey.png',
    component: D1,
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page49/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page49/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page49/E3/3.jpg', input: true, answer: "ou" },
        { url: 'img/FriendsPlus/Page49/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page49/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page49/E3/6.jpg', input: true, answer: "oi" },
        { url: 'img/FriendsPlus/Page49/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page49/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page49/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page49/E3/10.jpg', input: true, answer: "ow" },
        { url: 'img/FriendsPlus/Page49/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page49/E3/12.jpg', input: true, answer: "oy" },
        { url: 'img/FriendsPlus/Page49/E3/13.jpg' },
        { url: 'img/FriendsPlus/Page49/E3/14.jpg', input: true, answer: "oi" },
        { url: 'img/FriendsPlus/Page49/E3/15.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page49/E3/16.jpg' },
      ],


    ]
  },
  4: { // Exercise num
    unit: 'Review 2',
    id: 'SB4-PV2-P49-E4',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 1,
    exerciseKey: '',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page49/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page49/E4/2.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page49/E4/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page49/E4/4.jpg', input: 1, isCorrect: true },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page49/E4/5.jpg' },
      ],


    ],
    questions: [
      {
        title: 'The dictionaries are # the shelf',
        answer: ['table']
      },
    ]
  },

}
export default json;
